import * as React from 'react'
import styled from 'styled-components'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'
import * as colors from '../../../constants/colors'

const ID = 'discord-third-party-glyph-icon'

export function DiscordSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <g>
        <g clipPath="url(#discord-a)">
          <path d="M27.09 5.256a25.978 25.978 0 0 0-6.514-2.065.098.098 0 0 0-.105.05 18.963 18.963 0 0 0-.81 1.703 23.843 23.843 0 0 0-7.317 0 17.39 17.39 0 0 0-.823-1.702.102.102 0 0 0-.105-.05 25.904 25.904 0 0 0-6.513 2.064.094.094 0 0 0-.043.038C.71 11.628-.425 17.806.132 23.908c.003.03.02.058.042.076 2.737 2.054 5.388 3.301 7.99 4.128a.102.102 0 0 0 .113-.038 19.462 19.462 0 0 0 1.634-2.717.104.104 0 0 0-.055-.144 17.317 17.317 0 0 1-2.496-1.216.106.106 0 0 1-.01-.174c.167-.128.335-.262.495-.397a.097.097 0 0 1 .104-.014c5.237 2.443 10.906 2.443 16.082 0a.097.097 0 0 1 .104.013c.16.135.328.27.497.398a.106.106 0 0 1-.009.174c-.797.476-1.625.879-2.497 1.215a.105.105 0 0 0-.054.145c.48.951 1.029 1.857 1.633 2.716a.1.1 0 0 0 .113.039c2.614-.827 5.265-2.074 8.003-4.128a.105.105 0 0 0 .041-.075c.667-7.054-1.117-13.182-4.731-18.614a.083.083 0 0 0-.042-.04ZM10.692 20.192c-1.576 0-2.875-1.48-2.875-3.296 0-1.817 1.273-3.296 2.875-3.296 1.615 0 2.901 1.492 2.876 3.296 0 1.817-1.274 3.296-2.876 3.296Zm10.633 0c-1.576 0-2.875-1.48-2.875-3.296 0-1.817 1.273-3.296 2.875-3.296 1.615 0 2.901 1.492 2.876 3.296 0 1.817-1.261 3.296-2.876 3.296Z" />
        </g>
        <defs>
          <clipPath id="discord-a">
            <path fill={colors.PRIMARY_GREY_000} d="M0 0h32v32H0z" />
          </clipPath>
        </defs>
      </g>
    </symbol>
  )
}

const DiscordStandaloneContent = standalone(DiscordSymbol, ID)

export const Discord = styled(function DiscordStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-discord">
      <DiscordStandaloneContent />
    </Icon>
  )
})``

export const DiscordLightweight = styled(function DiscordComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-discord">
      {lightweight(ID)}
    </Icon>
  )
})``
